<!-- 商品管理 V2 - 商品维护详情页 -->
<template>
  <div class="product-detail-v2">
    <!-- 页面头部 -->
    <Head />

    <main v-loading="loading" class="detail-page">
      <!-- 顶部操作栏：全页滚动时粘性固定在顶部 -->
      <div class="action-bar">
        <!-- maintain_status=2 维护中：771 提交审核 / 772 提交无需维护 -->
        <el-button v-if="isAuth(771) && detail.maintain_status == 2" class="blue-button" @click="submitAudit">提交审核</el-button>
        <el-button v-if="isAuth(772) && detail.maintain_status == 2" class="blue-button" @click="submitNoNeed">提交无需维护</el-button>
        <!-- 769 保存商品详情 + 全部贩售方案 -->
        <el-button v-if="isAuth(769)" class="green-button" @click="saveDetail">保存修改</el-button>
        <!-- maintain_status=3 待审核：773 审核通过 -->
        <el-button v-if="isAuth(773) && detail.maintain_status == 3" class="red-button" @click="audit">审核</el-button>
      </div>

      <!-- 概览区：商品基础信息 -->
      <section class="overview-shell">
        <!-- 概览四列网格：商品信息 / 产品监控 / 发票+图片 / 商品文件 -->
        <div class="overview-grid">
          <!-- 商品信息卡片：主图、管理番号、中文标题 -->
          <article class="summary-card product-card">
            <h3>商品信息</h3>
            <div class="product-card-body">
              <div class="main-image-column">
                <div class="main-image-edit">
                  <!-- 主图预览，点击可放大 -->
                  <el-image class="main-image" :src="detail.base.pic" fit="cover" :preview-src-list="[detail.base.pic]" />
                  <!-- 主图上传：OSS 上传后回写 detail.base.pic -->
                  <el-upload class="main-image-upload" action="#" :show-file-list="false" :http-request="uploadMainImage">
                    <button type="button" title="修改主图"><i class="el-icon-edit"></i></button>
                  </el-upload>
                </div>
               
                <!-- 查看该商品历史采购链接 -->
                <el-button class="blue-button compact-button" @click="$refs.purchaseLinkDialog.open(detail)">采购商品链接</el-button>
              </div>
              <div class="product-fields">
                <!-- 管理番号 -->
                <p class="product-meta-text">管理番号：{{ detail.sys_code }}</p>
                <!-- SPU：有值同管理番号占满宽度；无值为立即绑定按钮 -->
                <div
                  v-if="detail.spu && detail.spu.spu"
                  class="spu-value"
                  @click="openBindSpu"
                >
                  <span>SPU：{{ detail.spu.spu }}</span>
                  <i class="el-icon-edit-outline"></i>
                </div>
                <button
                  v-else
                  type="button"
                  class="spu-bind-btn"
                  @click="openBindSpu"
                >{{ $t('message.productV2BindNow') }}</button>
                <!-- SKU 属性 -->
                <button type="button" class="sku-display" @click="$refs.skuEditDialog.open(detail.base.sku)">
                  <i class="el-icon-edit-outline"></i>
                  <span v-for="(sku, skuIndex) in detail.base.sku" :key="skuIndex">
                    {{ sku.key }}：{{ sku.value }}
                  </span>
                </button>
              </div>
            </div>
          </article>

          <!-- 产品监控卡片：违禁类型、供货类型、尺寸重量 -->
          <article class="summary-card monitor-card">
            <div class="editable-title">
              <h3>产品监控</h3>
              <i class="el-icon-edit-outline" @click="$refs.monitorEditDialog.openForbid(detail.base.forbid_type)"></i>
            </div>
            <!-- 违禁品类型 forbid_type -->
            <div class="monitor-tags">
              <span v-for="(item, index) in detail.base.forbid_type_names" :key="index">{{ item }}</span>
            </div>
            <div class="editable-title small-title"><h3>产品类型</h3><i class="el-icon-edit-outline" @click="$refs.monitorEditDialog.openSupply(detail.supply_types)"></i></div>
            <!-- 供货方式 supply_types：OEM/ODM 等 -->
            <div class="supply-list">
              <span
                v-for="item in ['现货', 'OEM', 'ODM']"
                :key="item"
                :class="detail.supply_types.indexOf(item) !== -1 ? 'supported' : 'unsupported'"
              >{{ item }} {{ detail.supply_types.indexOf(item) !== -1 ? '支持' : '不支持' }}</span>
            </div>
            <div class="metric-row">
              <label>单个产品尺寸 </label>
              <div class="metric-inputs">
                <el-input v-model="detail.base.length" type="number" min="0" @keydown.native="preventInvalidNumberKey($event, 2)" @paste.native="preventInvalidNumberPaste($event, 2)" @input="setBaseMetric('length', $event)" @blur="setBaseMetric('length', $event.target.value)" /><span>*</span><el-input v-model="detail.base.width" type="number" min="0" @keydown.native="preventInvalidNumberKey($event, 2)" @paste.native="preventInvalidNumberPaste($event, 2)" @input="setBaseMetric('width', $event)" @blur="setBaseMetric('width', $event.target.value)" /><span>*</span><el-input v-model="detail.base.height" type="number" min="0" @keydown.native="preventInvalidNumberKey($event, 2)" @paste.native="preventInvalidNumberPaste($event, 2)" @input="setBaseMetric('height', $event)" @blur="setBaseMetric('height', $event.target.value)" /><span>cm</span>
              </div>
            </div>
            <div class="metric-row weight-row">
              <label>单个产品重量 </label>
              <!-- 页面使用 kg，接口的 weight 字段仍按克接收和提交。 -->
              <div class="metric-inputs"><el-input v-model="weightKg" type="number" min="0" step="0.00001" @keydown.native="preventInvalidNumberKey($event, 5)" @paste.native="preventInvalidNumberPaste($event, 5)" @input="setWeightKg" @blur="setWeightKg($event.target.value)" /><span>kg</span></div>
            </div>
            <div class="metric-row forbid-logistics-row">
              <label>禁发物流</label>
              <button type="button" class="forbid-logistics-display" @click="$refs.monitorEditDialog.openLogistics(detail.base.forbid_logistics)">
                <span v-if="detail.base.forbid_logistics_names.length" class="forbid-logistics-names">
                  <span v-for="(name, index) in detail.base.forbid_logistics_names" :key="index">{{ name }}</span>
                </span>
                <span v-else class="forbid-logistics-placeholder">请选择禁发物流</span>
                <i class="el-icon-edit-outline"></i>
              </button>
            </div>
          </article>

          <!-- 发票管理 + 实物图/捆包图 -->
          <article class="invoice-group">
            <div class="summary-card invoice-card">
              <div class="invoice-head">
                <h3>发票管理</h3>
                <div class="invoice-actions">
                  <!-- 下单时是否自动带入当前通关信息 -->
                  <el-checkbox v-model="detail.clearance.auto_order" :true-label="1" :false-label="0">下单自动跟随</el-checkbox>
                  <!-- clearanceAiSuggest 接口回填品名/材质/HSCODE -->
                  <el-button class="blue-button compact-button" :loading="aiLoading" @click="loadAiClearance">AI自动获取</el-button>
                </div>
              </div>
              <!-- 通关信息 clearance：中英日品名/材质 + HSCODE -->
              <div class="clearance-grid">
                <div class="clearance-field">
                  <label>中文品名</label>
                  <el-input v-model="detail.clearance.pingming_zh" type="textarea"  resize="none" />
                </div>
                <div class="clearance-field">
                  <label>日文品名</label>
                  <el-input v-model="detail.clearance.pingming_ja" type="textarea"  resize="none" />
                </div>
                <div class="clearance-field">
                  <label>英文品名</label>
                  <el-input v-model="detail.clearance.pingming_en" type="textarea"  resize="none" />
                </div>
                <div class="clearance-field">
                  <label>HSCODE</label>
                  <el-input v-model="detail.clearance.hscode" type="textarea" resize="none" />
                </div>
                <div class="clearance-field">
                  <label>中文材质</label>
                  <el-input v-model="detail.clearance.material_zh" type="textarea"  resize="none" />
                </div>
                <div class="clearance-field">
                  <label>日文材质</label>
                  <el-input v-model="detail.clearance.material_ja" type="textarea"  resize="none" />
                </div>
                <div class="clearance-field">
                  <label>英文材质</label>
                  <el-input v-model="detail.clearance.material_en" type="textarea"  resize="none" />
                </div>
              </div>
            </div>
            <!-- 实物图 type=1 / 捆包图 type=2 -->
            <div class="summary-card image-card">
              <div class="image-group">
                <div class="image-group-head">
                  <h3>实物图</h3>
                  <el-upload action="#" :show-file-list="false" :http-request="file => uploadProductImage(file, 'real', 1)"><button type="button">上传</button></el-upload>
                </div>
                <div class="image-list">
                  <div v-for="(image, imageIndex) in detail.images.real" :key="image.id || imageIndex" class="image-item">
                    <el-image :src="image.url" fit="cover" :preview-src-list="detail.images.real.map(item => item.url)" />
                    <button type="button" @click="deleteProductImage('real', imageIndex)"><i class="el-icon-close"></i></button>
                  </div>
                </div>
              </div>
              <div class="image-divider"></div>
              <div class="image-group">
                <div class="image-group-head">
                  <h3>捆包图</h3>
                  <el-upload action="#" :show-file-list="false" :http-request="file => uploadProductImage(file, 'pack', 2)"><button type="button">上传</button></el-upload>
                </div>
                <div class="image-list">
                  <div v-for="(image, imageIndex) in detail.images.pack" :key="image.id || imageIndex" class="image-item">
                    <el-image :src="image.url" fit="cover" :preview-src-list="detail.images.pack.map(item => item.url)" />
                    <button type="button" @click="deleteProductImage('pack', imageIndex)"><i class="el-icon-close"></i></button>
                  </div>
                </div>
              </div>
            </div>
          </article>

          <!-- 商品文件：按分类上传与下载 -->
          <article class="summary-card file-card">
            <h3>商品文件</h3>
            <div v-for="(category, categoryIndex) in detail.files" :key="category.id || categoryIndex" class="file-category">
              <div class="file-category-head">
                <strong>{{ category.cate_name }}</strong>
                <el-upload action="#" :show-file-list="false" :http-request="file => uploadProductFile(file, category)">
                  <button type="button">上传</button>
                </el-upload>
              </div>
              <div class="file-links">
                <div v-for="(file, fileIndex) in category.files" :key="file.id || fileIndex" class="file-row">
                  <a :href="file.url" target="_blank" rel="noopener noreferrer">{{ file.name }}</a>
                  <button type="button" @click="deleteProductFile(category, fileIndex)"><i class="el-icon-delete"></i></button>
                </div>
              </div>
            </div>
            <!-- 发货文件分类专用：保存时写入 invoice_follow / sync_logistics -->
            <el-checkbox v-model="detail.ui_flags.invoice_follow">发票跟随</el-checkbox>
            <el-checkbox v-model="detail.ui_flags.sync_logistics">同步物流公司</el-checkbox>
          </article>
        </div>
      </section>

      <!-- 贩售方案区：多方案 Tab 切换及方案内配置 -->
      <section class="plan-shell">
        <h2>贩售方案</h2>
        <!-- 方案 Tab 列表，最多 10 个 -->
        <div class="plan-tabs">
          <button
            v-for="(plan, index) in detail.order_plans"
            :key="plan.id || index"
            type="button"
            :class="{ active: activePlanIndex === index }"
            @click="activePlanIndex = index"
          >{{ plan.name }}</button>
          <div class="plan-create">
            <span>{{ detail.order_plans.length }}/10</span>
            <!-- <el-button class="blue-button" @click="generateDefaultPlan">{{ $t('message.generateDefaultPlan') }}</el-button> -->
            <el-button class="green-button" @click="createPlanInline">{{ $t('message.createPlan') }}</el-button>
          </div>
        </div>

        <!-- 当前选中方案的编辑器：下单链接 / 注意事项 / OPTION / 标签 -->
        <!-- plan-editor：方案内保存 / 设默认 / 复制 / 删除 -->
        <plan-editor
          v-if="detail.order_plans.length"
          :plan="detail.order_plans[activePlanIndex]"
          :detail="detail"
          :saving="planSaving"
          @save="saveOrderPlan"
          @set-default="setDefaultPlan"
          @copy="copyPlan"
          @delete="deletePlan"
        />
       
      </section>

      <!-- 下单记录列表（含关联赔款） -->
      <section class="records-shell">
        <div class="records-header">
          <div class="records-title">
            <h2>{{ $t('message.productV2OrderHistory') }}</h2>
            <!-- 下单记录同步说明 -->
            <p class="records-tip">{{ $t('message.productV2OrderHistoryTip') }}</p>
          </div>
          <!-- 按当前客户补订单明细 for_sn，完成后刷新下单记录 -->
          <el-button type="primary" size="small" class="sync-btn" @click="syncOrderDetailForSn">
            {{ $t('message.synchronization') }}
          </el-button>
        </div>
        <div class="native-table order-table">
          <div class="table-head order-grid"><div>订单号</div><div>下单数量</div><div>订单类型</div><div>关联赔款</div><div>日期</div></div>
          <div v-for="record in orderRecords" :key="record.order_sn" class="table-row order-grid">
            <div><router-link :to="'/orderDetail?order_sn=' + record.order_sn" target="_blank">{{ record.order_sn }}</router-link></div>
            <div>{{ record.num }}</div>
            <div class="order-type-cell">{{ record.type_name }}</div>
            <div class="reparation-links">
              <div
                v-for="reparation in record.reparations"
                :key="reparation.reparation_sn"
                class="reparation-item"
              >
                <router-link
                  :to="{ name: 'reparationList', query: { reparation_sn: reparation.reparation_sn } }"
                  target="_blank"
                >{{ reparation.reparation_sn }}</router-link>
                <!-- 一张赔款单可能同时返回主责任人和关联责任人，按接口数组逐条展示。 -->
                <p
                  v-for="(responsible, responsibleIndex) in reparation.reparation_amount"
                  :key="responsible.type + '-' + responsibleIndex"
                  class="reparation-responsible"
                >{{ responsible.type_name }}：{{ responsible.main_name }}</p>
              </div>
              <span v-if="!record.reparations.length">-</span>
            </div>
            <div>{{ record.ordered_at }}</div>
          </div>
        </div>
        <!-- 下单记录分页：orderHistory 接口 -->
        <el-pagination
          class="history-pagination"
          :current-page="historyPage"
          :page-sizes="historyPageSizes"
          :page-size="historyPageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="historyTotal"
          @size-change="changeHistoryPageSize"
          @current-change="changeHistoryPage"
        />
      </section>

      <!-- 购买渠道：线上/线下、付款模式、合同、联系人（字段变更即单字段保存） -->
      <buy-channel-editor :detail="detail" />

      <!-- 弹窗组件：编辑后仅回写页面，随「保存修改」统一提交 -->
      <!-- 产品监控：违禁品类型 / 产品类型 / 禁发物流 -->
      <monitor-edit-dialog
        ref="monitorEditDialog"
        @confirm-forbid="updateForbidTypes"
        @confirm-supply="updateSupplyTypes"
        @confirm-logistics="updateForbidLogistics"
      />
      <!-- 历史采购链接查看 -->
      <purchase-link-dialog ref="purchaseLinkDialog" />
      <!-- SPU 绑定：与列表共用弹框，绑定/解绑同步 detail.spu -->
      <bind-spu-dialog ref="bindSpuDialog" @change="onSpuChange" />
      <!-- SKU 属性键值对编辑 -->
      <sku-edit-dialog ref="skuEditDialog" @confirm="updateSku" />

    </main>
  </div>
</template>

<script>
import Head from '@/components/header/detailHeader' // 详情页公共头部
import PlanEditor from './components/planEditor' // 贩售方案编辑器
import MonitorEditDialog from './components/monitorEditDialog' // 产品监控弹窗
import PurchaseLinkDialog from './components/purchaseLinkDialog' // 采购链接历史弹窗
import BuyChannelEditor from './components/buyChannelEditor' // 购买渠道区块
import SkuEditDialog from './components/skuEditDialog' // SKU 属性编辑弹窗
import bindSpuDialog from '../components/bindSpuDialog' // SPU 绑定弹窗（与列表共用）

/**
 * 商品维护详情页
 * 路由入参：user_id、sys_code
 * 主接口：detailGet / detailSave / orderPlanStore|Update|Delete / orderHistory
 */
export default {
  name: 'ProductManagementV2Detail',
  components: { Head, PlanEditor, MonitorEditDialog, PurchaseLinkDialog, BuyChannelEditor, SkuEditDialog, bindSpuDialog },
  data() {
    return {
      loading: false, // 详情加载中
      saving: false, // 保存中
      planSaving: false, // 贩售方案保存中
      aiLoading: false, // AI 获取通关信息中
      activePlanIndex: 0, // 当前选中的贩售方案下标
      orderRecords: [], // 下单记录列表
      historyPage: 1, // 下单记录当前页
      historyPageSize: 10, // 下单记录每页条数
      historyPageSizes: [10, 20, 50,100,200], // 下单记录分页可选条数
      historyTotal: 0, // 下单记录总条数
      weightKg: 0, // 页面展示的千克重量，接口仍使用 detail.base.weight 克
      detail: this.createEmptyDetail() // 商品详情主数据
    }
  },
  // 校验路由参数后加载详情与下单记录
  created() {
    // 路由必须携带 user_id、sys_code
    if (!this.$route.query.user_id || !this.$route.query.sys_code) {
      this.$message.error('缺少客户ID或系统番号')
      this.$router.replace({ name: 'productManagementV2' })
      return
    }
    this.loadDetail()
    this.loadOrderHistory()
  },
  methods: {
    // 详情数据结构默认值
    createEmptyDetail() {
      return {
        base: {
          pic: '', // 主图
          goods_title: '',
          goods_title_cn: '',
          remark: '',
          remark_auto_order: 0,
          y_remark: '',
          y_remark_auto_order: 0,
          option: [],
          length: '0.00', // 尺寸 cm
          width: '0.00',
          height: '0.00',
          weight: 0, // 重量 g
          sku: [], // 商品属性键值对
          forbid_type: [], // 违禁品类型 id 列表
          forbid_logistics: [], // 禁发物流 id 列表
          forbid_logistics_names: [] // 禁发物流名称，仅用于展示
        },
        supply_types: [], // 产品类型：现货/OEM/ODM
        clearance: {}, // 通关品名/材质/HSCODE
        buy_channel: {}, // 购买渠道
        images: { real: [], pack: [] }, // 实物图 / 捆包图
        files: [], // 商品文件分类
        notice: { // 注意事项：商品/验货/采购/发货等，use=1 表示下单自动带入
          remark: { text: '', use: 0 },
          y_remark: { text: '', use: 0 },
          purchase_notice: { text: '', use: 0 },
          inspect_notice: { text: '', use: 0 },
          delivery_notice: { text: '', use: 0 }
        },
        links: [], // 采购链接
        order_plans: [], // 贩售方案列表
        ui_flags: {
          invoice_follow: false, // 发货文件-发票跟随
          sync_logistics: false, // 发货文件-同步物流公司
          clearance_auto_suggest: false
        }
      }
    },
    // 新建方案只追加到页面数据，保存前不请求接口
    createEmptyPlan() {
      return {
        name: `贩售方案${this.detail.order_plans.length + 1}`,
        is_default: 1, // 是否默认方案
        is_main: 0,
        parent_id: 0,
        link: '', // 下单链接
        from_platform: '', // 来源平台
        goods_id: '',
        goods_title: '',
        price: 0,
        num: 1, // 默认下单数量
        pic: '',
        detail: [], // 链接解析出的商品属性
        sku_id: '',
        spec_id: '',
        shop_id: '',
        shop_name: '',
        option: [], // 附加服务
        client_remark: '',
        notice: {
          remark: { text: '', use: 1 },
          y_remark: { text: '', use: 1 },
          purchase_notice: { text: '', use: 1 },
          inspect_notice: { text: '', use: 1 },
          delivery_notice: { text: '', use: 1 }
        },
        order_detail_tag: [], // 标签配置
        material: [], // 辅料
        files: [],
        children: [] // 组合商品子项
      }
    },
    // 详情/下单记录接口公共入参
    getDetailParams() {
      return {
        user_id: Number(this.$route.query.user_id),
        sys_code: this.$route.query.sys_code
      }
    },
    // 加载商品详情 detailGet
    loadDetail() {
      this.loading = true
      return this.$api.productManagementApi.detailGet(this.getDetailParams()).then(res => {
        const firstPlan = res.data.order_plans && res.data.order_plans[0]
        // 注意事项优先取 detail.notice，缺失时回退到 detail 根字段或首个方案
        if (res.data.notice == null) res.data.notice = {}
        ;['remark', 'y_remark', 'purchase_notice', 'inspect_notice', 'delivery_notice'].forEach(key => {
          if (res.data.notice[key] == null && res.data[key] != null) {
            res.data.notice[key] = res.data[key]
          }
        })
        if (firstPlan) {
          ;['remark', 'y_remark', 'purchase_notice', 'inspect_notice', 'delivery_notice'].forEach(key => {
            if (res.data.notice[key] == null && firstPlan[key] != null) {
              res.data.notice[key] = firstPlan[key]
            }
            if (res.data.notice[key] == null && firstPlan.notice && firstPlan.notice[key] != null) {
              res.data.notice[key] = firstPlan.notice[key]
            }
          })
        }
        if (res.data.buy_channel === null) {
          res.data.buy_channel = this.createEmptyDetail().buy_channel
        }
        const emptyNotice = this.createEmptyDetail().notice
        ;['remark', 'y_remark', 'purchase_notice', 'inspect_notice', 'delivery_notice'].forEach(key => {
          if (res.data.notice[key] == null) {
            this.$set(res.data.notice, key, emptyNotice[key])
          }
          res.data.notice[key].use = Number(res.data.notice[key].use) ? 1 : 0
        })
        if (res.data.base.sku == null) {
          this.$set(res.data.base, 'sku', [])
        }
        this.$set(res.data.base, 'forbid_logistics', (res.data.base.forbid_logistics || []).map(id => Number(id)))
        this.$set(res.data.base, 'forbid_logistics_names', res.data.base.forbid_logistics_names || [])
        // 方案附加服务/辅料/组合商品字段归一化，兼容旧接口结构
        ;(res.data.order_plans || []).forEach(plan => {
          plan.option = this.normalizeOptions(plan.option)
          plan.material = this.normalizeMaterials(plan.material)
          if (plan.notice) {
            ;['remark', 'y_remark', 'purchase_notice', 'inspect_notice', 'delivery_notice'].forEach(key => {
              const value = plan.notice[key] || res.data.notice[key]
              this.$set(plan.notice, key, { text: value.text, use: Number(value.use) ? 1 : 0 })
            })
          }
          ;(plan.children || []).forEach(child => {
            child.auto_order = Number(child.auto_order) ? 1 : 0
            child.option = this.normalizeOptions(child.option)
          })
        })
        this.detail = res.data
        // 详情接口返回克，页面统一换算成千克展示。
        this.weightKg = res.data.base.weight / 1000
      }).finally(() => {
        this.loading = false
      })
    },
    // 加载下单记录 orderHistory
    loadOrderHistory() {
      this.$api.productManagementApi.orderHistory({
        ...this.getDetailParams(),
        page: this.historyPage,
        pageSize: this.historyPageSize
      }).then(res => {
        this.orderRecords = res.data.list
        this.historyPage = res.data.page
        this.historyPageSize = res.data.pageSize
        this.historyTotal = res.data.total
      })
    },
    // 按客户补订单明细 for_sn，完成后刷新下单记录
    syncOrderDetailForSn() {
      this.$api.productManagementApi.syncOrderDetailForSn({
        user_id: Number(this.$route.query.user_id),
        sys_code: this.$route.query.sys_code
      }).then(res => {
        this.$message.success(res.msg)
        this.historyPage = 1
        this.loadOrderHistory()
      })
    },
    // 切换下单记录页码
    changeHistoryPage(page) {
      this.historyPage = page
      this.loadOrderHistory()
    },
    // 修改下单记录每页条数时回到第一页重新查询
    changeHistoryPageSize(pageSize) {
      this.historyPageSize = pageSize
      this.historyPage = 1
      this.loadOrderHistory()
    },
    // 过滤非负数字输入，限制小数位数
    sanitizeNonNegative(value, decimals = 2) {
      if (value === '' || value == null) return ''
      const text = String(value).replace(/[^\d.]/g, '')
      const dotIndex = text.indexOf('.')
      const integer = text.slice(0, dotIndex === -1 ? text.length : dotIndex) || '0'
      if (dotIndex === -1 || decimals === 0) return integer
      const fraction = text.slice(dotIndex + 1).replace(/\./g, '').slice(0, decimals)
      return integer + '.' + fraction
    },
    // 尺寸/重量输入框键盘拦截
    preventInvalidNumberKey(event, decimals) {
      if (event.ctrlKey || event.metaKey || ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return
      if (event.key === '.' && decimals > 0 && !event.target.value.includes('.')) return
      if (!/^\d$/.test(event.key)) event.preventDefault()
    },
    // 尺寸/重量输入框粘贴校验
    preventInvalidNumberPaste(event, decimals) {
      const value = event.clipboardData.getData('text')
      const pattern = decimals > 0 ? new RegExp('^\\d*(\\.\\d{0,' + decimals + '})?$') : /^\d*$/
      if (!pattern.test(value)) event.preventDefault()
    },
    // 长宽高（cm）输入清洗
    setBaseMetric(field, value) {
      this.$set(this.detail.base, field, this.sanitizeNonNegative(value, 2))
    },
    // 千克输入保留五位小数，对应接口克字段原有的两位小数精度。
    setWeightKg(value) {
      this.weightKg = this.sanitizeNonNegative(value, 5)
    },
    // 保存商品详情，贩售方案由方案内的保存按钮单独提交
    async saveDetail() {
      const form = {
        client_sku_code: this.detail.client_sku_code,
        base: {
          ...this.detail.base,
          length: this.sanitizeNonNegative(this.detail.base.length, 2),
          width: this.sanitizeNonNegative(this.detail.base.width, 2),
          height: this.sanitizeNonNegative(this.detail.base.height, 2),
          weight: Number(this.weightKg) * 1000,
          sku: this.detail.base.sku.map(item => ({ key: item.key, value: item.value })),
          forbid_type: this.detail.base.forbid_type.map(id => Number(id)),
          forbid_logistics: this.detail.base.forbid_logistics.map(id => Number(id))
        },
        supply_types: this.detail.supply_types,
        clearance: {
          ...this.detail.clearance,
          auto_order: this.detail.clearance.auto_order
        },
        images: this.detail.images,
        files: this.detail.files.map(category => category.cate_name === '发货文件'
          ? {
            ...category,
            invoice_follow: this.detail.ui_flags.invoice_follow ? 1 : 0,
            sync_logistics: this.detail.ui_flags.sync_logistics ? 1 : 0
          }
          : category),
        remark: { text: this.detail.notice.remark.text, use: Number(this.detail.notice.remark.use) ? 1 : 0 },
        y_remark: { text: this.detail.notice.y_remark.text, use: Number(this.detail.notice.y_remark.use) ? 1 : 0 },
        purchase_notice: { text: this.detail.notice.purchase_notice.text, use: Number(this.detail.notice.purchase_notice.use) ? 1 : 0 },
        inspect_notice: { text: this.detail.notice.inspect_notice.text, use: Number(this.detail.notice.inspect_notice.use) ? 1 : 0 },
        delivery_notice: { text: this.detail.notice.delivery_notice.text, use: Number(this.detail.notice.delivery_notice.use) ? 1 : 0 },
        links: this.detail.links
      }
      delete form.base.forbid_logistics_names
      if (this.detail.sys_code) form.sys_code = this.detail.sys_code

      this.saving = true
      try {
        const res = await this.$api.productManagementApi.detailSave({
          user_id: this.detail.user_id,
          form
        })
        await this.savePlans()
        this.$message.success(res.msg || '保存成功')
        await this.loadDetail()
      } finally {
        this.saving = false
      }
    },
    // 单独保存当前贩售方案
    async saveOrderPlan() {
      const plan = this.detail.order_plans[this.activePlanIndex]
      this.planSaving = true
      try {
        const payload = this.buildPlanPayload(plan)
        const res = plan.id
          ? await this.$api.productManagementApi.orderPlanUpdate({ ...payload, id: plan.id })
          : await this.$api.productManagementApi.orderPlanStore(payload)
        if (!plan.id && res.data && (res.data.id || res.data.plan_id)) {
          this.$set(plan, 'id', res.data.id || res.data.plan_id)
        }
        this.$message.success(res.msg || '保存成功')
      } finally {
        this.planSaving = false
      }
    },
    // 整页保存时逐个保存贩售方案：有 ID 调修改，无 ID 调新建，每个方案保存一次，不处理删除。
    async savePlans() {
      for (const plan of this.detail.order_plans) {
        const payload = this.buildPlanPayload(plan)
        const res = plan.id
          ? await this.$api.productManagementApi.orderPlanUpdate({ ...payload, id: plan.id })
          : await this.$api.productManagementApi.orderPlanStore(payload)
        if (!plan.id && res.data && (res.data.id || res.data.plan_id)) {
          this.$set(plan, 'id', res.data.id || res.data.plan_id)
        }
      }
    },
    // 统一附加服务字段，兼容详情接口可能返回的旧扩展字段
    normalizeOptions(options) {
      return (Array.isArray(options) ? options : []).map(option => {
        const item = { ...option }
        item.checked = item.checked == null ? true : (item.checked === true || Number(item.checked) === 1)
        if (item.name_ja == null) item.name_ja = item.name_translate || ''
        if (item.special_requirement == null) item.special_requirement = item.remark_ext || ''
        if (item.images == null) item.images = item.image_ext || []
        if (item.videos == null) item.videos = item.video_ext || []
        if (item.files == null) item.files = item.file_ext || []
        return item
      })
    },
    // 方案辅料接口将展示字段放在 material_detail，回填到当前编辑器使用的扁平字段。
    normalizeMaterials(materials) {
      return (Array.isArray(materials) ? materials : []).map(item => {
        const materialDetail = item.material_detail || {}
        return {
          ...item,
          material_id: item.material_id || materialDetail.id,
          consume: item.consume,
          name: item.name || materialDetail.name_trans || materialDetail.name || '',
          name_trans: item.name_trans || materialDetail.name_trans || materialDetail.name || '',
          main_image: item.main_image || materialDetail.main_image || '',
          material_stock_num: item.material_stock_num == null
            ? materialDetail.material_stock_num
            : item.material_stock_num,
          type_name: item.type_name || (materialDetail.type && materialDetail.type.name) || ''
        }
      })
    },
    // 附加服务人效比为空时不提交，由接口按默认值 0 处理
    buildOptionPayload(option) {
      const {
        id,
        name_translate,
        image_ext,
        video_ext,
        file_ext,
        remark_ext,
        ...data
      } = option
      const payload = {
        ...data,
        name_ja: option.name_ja != null ? option.name_ja : (name_translate || ''),
        images: option.images || image_ext || [],
        videos: option.videos || video_ext || [],
        files: option.files || file_ext || [],
        special_requirement: option.special_requirement != null
          ? option.special_requirement
          : (remark_ext || '')
      }
      if (payload.work_seconds === '' || payload.work_seconds == null) {
        delete payload.work_seconds
      } else {
        payload.work_seconds = parseInt(payload.work_seconds, 10) || 0
      }
      return payload
    },
    // 第一版方案接口字段
    buildPlanPayload(plan) {
      const notice = plan.notice || this.detail.notice
      return {
        user_id: this.detail.user_id,
        sys_code: this.detail.sys_code,
        data: {
          name: plan.name,
          is_default: plan.is_default,
          link: plan.link,
          from_platform: plan.from_platform,
          goods_id: plan.goods_id,
          goods_title: plan.goods_title,
          price: plan.price,
          num: plan.num,
          pic: plan.pic,
          detail: plan.detail
            .filter(item => String(item.key || '').trim() && String(item.value || '').trim())
            .map(item => ({ key: item.key, value: item.value })),
          sku_id: plan.sku_id,
          spec_id: plan.spec_id,
          shop_id: plan.shop_id,
          shop_name: plan.shop_name,
          option: plan.option.map(option => this.buildOptionPayload(option)),
          client_remark: plan.client_remark,
          notice: {
            remark: { text: notice.remark.text, use: Number(notice.remark.use) ? 1 : 0 },
            y_remark: { text: notice.y_remark.text, use: Number(notice.y_remark.use) ? 1 : 0 },
            purchase_notice: { text: notice.purchase_notice.text, use: Number(notice.purchase_notice.use) ? 1 : 0 },
            inspect_notice: { text: notice.inspect_notice.text, use: Number(notice.inspect_notice.use) ? 1 : 0 },
            delivery_notice: { text: notice.delivery_notice.text, use: Number(notice.delivery_notice.use) ? 1 : 0 }
          },
          order_detail_tag: plan.order_detail_tag.map(item => ({
            type: item.type,
            no: item.no,
            goods_no: item.goods_no,
            code_type: item.code_type,
            text_line_one: item.text_line_one,
            text_line_two: item.text_line_two,
            text_line_three: item.text_line_three,
            text_line_four: item.text_line_four
          })),
          material: plan.material.map(item => ({ material_id: item.material_id, consume: item.consume })),
          files: plan.files,
          children: plan.children.map(item => ({
            id: item.id,
            name: item.name,
            link: item.link,
            from_platform: item.from_platform,
            goods_id: item.goods_id,
            goods_title: item.goods_title,
            price: item.price,
            num: item.num,
            pic: item.pic,
            detail: item.detail
              .filter(detail => String(detail.key || '').trim() && String(detail.value || '').trim())
              .map(detail => ({ key: detail.key, value: detail.value })),
            sku_id: item.sku_id,
            spec_id: item.spec_id,
            shop_id: item.shop_id,
            shop_name: item.shop_name,
            option: item.option.map(option => this.buildOptionPayload(option)),
            client_remark: item.client_remark,
            auto_order: Number(item.auto_order) ? 1 : 0
          }))
        }
      }
    },
    // 批量操作二次确认封装
    confirmAction(apiName, data) {
      return this.$confirm('确认执行当前操作？', '提示', { type: 'warning' })
        .then(() => this.$api.productManagementApi[apiName](data))
        .then(res => {
          this.$message.success(res.msg || '操作成功')
          this.loadDetail()
        })
        .catch(() => {})
    },
    // 提交审核
    submitAudit() {
      this.confirmAction('submitAudit', { sys_code_set: [this.detail.sys_code] })
    },
    // 提交无需维护
    submitNoNeed() {
      this.confirmAction('submitNoNeed', { sys_code_set: [this.detail.sys_code] })
    },
    // 审核通过
    audit() {
      this.confirmAction('batchAudit', { sys_code_set: [this.detail.sys_code], action: 'approve' })
    },
    // AI 自动获取通关品名/材质/HSCODE
    loadAiClearance() {
      this.aiLoading = true
      this.$api.productManagementApi.clearanceAiSuggest(this.getDetailParams()).then(res => {
        Object.assign(this.detail.clearance, res.data.suggested)
      }).finally(() => {
        this.aiLoading = false
      })
    },
    // 弹窗确认后只回写当前页面，整页保存时统一提交
    // 产品监控弹窗确认：违禁品类型
    updateForbidTypes(data) {
      this.$set(this.detail.base, 'forbid_type', data.ids)
      this.$set(this.detail.base, 'forbid_type_names', data.names)
    },
    // 产品类型弹窗确认：现货/OEM/ODM
    updateSupplyTypes(list) {
      this.$set(this.detail, 'supply_types', list)
    },
    // 禁发物流弹窗确认：ID 用于保存，名称用于页面展示。
    updateForbidLogistics(data) {
      this.$set(this.detail.base, 'forbid_logistics', data.ids)
      this.$set(this.detail.base, 'forbid_logistics_names', data.names)
    },
    // 打开 SPU 绑定弹框（补齐 user_id，与列表共用同一弹框逻辑）
    openBindSpu() {
      if (!this.detail.user_id) {
        this.$set(this.detail, 'user_id', Number(this.$route.query.user_id))
      }
      this.$refs.bindSpuDialog.open(this.detail)
    },
    // 绑定/解绑后同步详情页展示（弹框内也会写 product.spu）
    onSpuChange(spu) {
      this.$set(this.detail, 'spu', spu)
    },
    // SKU 属性弹窗确认
    updateSku(sku) {
      // SKU 属性回填时过滤空属性，全部为空则保存为空数组。
      const cleanSku = (Array.isArray(sku) ? sku : [])
        .map(item => ({
          key: String(item.key || '').trim(),
          value: String(item.value || '').trim()
        }))
        .filter(item => item.key || item.value)
      this.$set(this.detail.base, 'sku', cleanSku)
    },
    // 上传到 OSS 后只修改当前页面，整页保存时统一提交
    async uploadMainImage(file) {
      const result = await this.createClient(file)
      this.detail.base.pic = result.data
    },
    // 实物图、捆包图只更新当前页面数据
    async uploadProductImage(file, group, type) {
      const result = await this.createClient(file)
      this.detail.images[group].push({ url: result.data, type, is_hide: 0, link_id: 0 })
    },
    // 删除实物图/捆包图（仅本地，保存时提交）
    deleteProductImage(group, index) {
      this.detail.images[group].splice(index, 1)
    },
    // 商品文件只追加到当前页面分类
    async uploadProductFile(file, category) {
      const result = await this.createClient(file)
      category.files.push({ url: result.data, name: file.file.name, cate_id: category.id })
    },
    // 删除商品文件（仅本地，保存时提交）
    deleteProductFile(category, index) {
      category.files.splice(index, 1)
    },
    // 页面内创建方案
    createPlanInline() {
      if (this.detail.order_plans.length >= 10) {
        this.$message.warning('同一商品管理番号，方案最多10个，请确认后在操作')
        return
      }
      const orderPlans = this.detail.order_plans.concat(this.createEmptyPlan())
      this.$set(this.detail, 'order_plans', orderPlans)
      this.activePlanIndex = orderPlans.length - 1
    },
    // 根据最近一次下单数据生成默认方案
    generateDefaultPlan() {
      this.$api.productManagementApi.generateDefaultPlan({
        user_id: this.detail.user_id,
        sys_code: this.detail.sys_code
      }).then(res => {
        this.$message.success(res.msg || this.$t('message.saveSuccess'))
        this.loadDetail()
      })
    },
    // 本地复制当前方案（未保存的无 id 副本）
    copyPlan() {
      if (this.detail.order_plans.length >= 10) {
        this.$message.warning('同一商品管理番号，方案最多10个，请确认后在操作')
        return
      }
      const copy = JSON.parse(JSON.stringify(this.detail.order_plans[this.activePlanIndex]))
      delete copy.id
      copy.name = `${copy.name || ''} copy`
      this.detail.order_plans.push(copy)
      this.activePlanIndex = this.detail.order_plans.length - 1
    },
    // 已保存方案调用删除接口，未保存方案直接从页面移除
    async deletePlan() {
      const index = this.activePlanIndex
      const plan = this.detail.order_plans[index]
      if (plan.id) {
        this.planSaving = true
        try {
          const res = await this.$api.productManagementApi.orderPlanDelete({
            user_id: this.detail.user_id,
            sys_code: this.detail.sys_code,
            id: plan.id
          })
          this.$message.success(res.msg || '删除成功')
        } finally {
          this.planSaving = false
        }
      }
      this.detail.order_plans.splice(index, 1)
      this.activePlanIndex = Math.max(0, Math.min(this.activePlanIndex, this.detail.order_plans.length - 1))
    },
    // 默认方案只更新本地数据
    setDefaultPlan(checked) {
      this.detail.order_plans.forEach((plan, index) => { plan.is_default = index === this.activePlanIndex && checked ? 1 : 0 })
    }
  }
}
</script>

<style lang="scss" scoped>
/* 页面容器 */
.product-detail-v2 {
  min-width: 1910px;
  min-height: 100vh;
  background: #fff;
  color: #333;
  font-size: 14px;
}

.detail-page { padding: 24px; }
/* 概览区 / 贩售方案区公共容器 */
.overview-shell,
.plan-shell { padding: 24px; border-radius: 8px; background: #f8f8f8; }
/* 顶部操作栏：全页 sticky */
.action-bar {
  position: sticky;
  top: 0;
  z-index: 99;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  min-height: 40px;
  margin: -24px -24px 24px;
  padding: 12px 24px;
  border-radius: 0;
  background: #fff;
  box-shadow: 0 1px 0 #ebeef5;
}
.action-bar .el-button { margin: 0; }
/* 操作按钮主题色 */
.blue-button { border-color: #2c96e7 !important; background: #2c96e7 !important; color: #fff !important; }
.green-button { border-color: #15ad3c !important; background: #15ad3c !important; color: #fff !important; }
.red-button { border-color: #b4272d !important; background: #b4272d !important; color: #fff !important; }
.compact-button { height: 34px; padding: 0 12px; }
h2 { margin: 0 0 24px; font-size: 24px; line-height: 32px; }
h3 { margin: 0; font-size: 16px; line-height: 22px; }

/* 概览四列：商品信息 | 产品监控 | 发票+图片 | 商品文件 */
.overview-grid { display: grid; grid-template-columns: auto 338px 654px 300px; gap: 24px; align-items: stretch; }
.summary-card { box-sizing: border-box; padding: 18px; border-radius: 8px; background: #fff; box-shadow: 0 1px 3px rgba(0, 0, 0, .03); }

.product-card-body { display: grid; grid-template-columns: 150px minmax(0, 1fr); gap: 14px; margin-top: 18px; }
.main-image-column { display: flex; flex-direction: column; align-items: center; gap: 12px; }
.main-image-edit { position: relative; width: 150px; height: 150px; }
.main-image { width: 150px; height: 150px; border-radius: 8px; background: #d8d8d8; }
.main-image-upload { position: absolute; top: 8px; right: 8px; }
.main-image-upload button { display: flex; align-items: center; justify-content: center; width: 28px; height: 28px; padding: 0; border: 0; border-radius: 4px; background: rgba(0, 0, 0, .58); color: #fff; cursor: pointer; }
.product-fields { display: flex; flex-direction: column; align-items: flex-start; gap: 12px; min-width: 0; }
.product-meta-text {
  width: 100%;
  margin: 0;
  line-height: 22px;
}
.product-fields .el-input { width: 100%; }
/* 有绑定 SPU：与管理番号一样占满宽度 */
.spu-value {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 32px;
  margin: 0;
  padding: 0 12px;
  border: 0;
  border-radius: 4px;
  background: #f2f6ff;
  color: #0d4fe6;
  font-size: 13px;
  line-height: 32px;
  cursor: pointer;
  box-sizing: border-box;
}
.spu-value span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.spu-value i { flex: 0 0 auto; margin-left: 6px; color: #0d4fe6; font-size: 14px; }
/* 无绑定：立即绑定按钮，宽度随内容 */
.spu-bind-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: auto;
  height: 32px;
  margin: 0;
  padding: 0 12px;
  border: 0;
  border-radius: 4px;
  background: #f2f6ff;
  color: #0d4fe6;
  font-size: 13px;
  line-height: 32px;
  white-space: nowrap;
  cursor: pointer;
  box-sizing: border-box;
}
.sku-display { position: relative; box-sizing: border-box; display: flex; flex-direction: column; gap: 8px; width: 100%; height: 220px; padding: 14px; overflow: auto; border: 1px solid #dcdfe6; border-radius: 4px; background: #fff; color: #333; text-align: left; cursor: pointer; }
.sku-display > i { position: absolute; top: 12px; right: 12px; color: #606266; font-size: 18px; }
.sku-display span { padding-right: 28px; line-height: 22px; }
.editable-title { display: flex; justify-content: space-between; align-items: center; }
.editable-title i,
.metric-row i,
.image-group-head i { color: #666; cursor: pointer; }
.small-title { margin-top: 18px; }
.monitor-tags,
.supply-list { display: flex; flex-wrap: wrap; gap: 8px; min-height: 26px; margin-top: 10px; }
.monitor-tags span { padding: 3px 8px; border: 1px solid #e05a61; border-radius: 3px; background: #fff; color: #e05a61; font-size: 12px; }
.supply-list span { padding: 3px 8px; border: 1px solid; border-radius: 3px; background: #fff; font-size: 12px; }
.supply-list .supported { border-color: #15ad3c; color: #15ad3c; }
.supply-list .unsupported { border-color: #e05a61; color: #e05a61; }
.metric-row { margin-top: 18px; }
.metric-row label { display: block; margin-bottom: 8px; font-weight: 700; }
.metric-row label i { float: right; font-weight: 400; }
.metric-inputs { display: flex; align-items: center; gap: 4px; }
.metric-inputs .el-input { flex: 1 1 0; width: auto; min-width: 0; }
.weight-row { margin-top: 14px; }
.weight-row .metric-inputs .el-input { flex: 0 0 110px; width: 110px; }
.forbid-logistics-display { display: flex; align-items: flex-start; justify-content: space-between; gap: 8px; width: 100%; min-height: 44px; padding: 8px 10px; border-radius: 4px; background: #fff; text-align: left; cursor: pointer; }
.forbid-logistics-names { display: flex; flex-wrap: wrap; gap: 6px; min-width: 0; }
.forbid-logistics-names span { padding: 2px 6px; border: 1px solid #e05a61; border-radius: 3px; color: #e05a61; font-size: 12px; overflow-wrap: anywhere; }
.forbid-logistics-placeholder { color: #909399; }
.forbid-logistics-display i { flex: 0 0 auto; margin-top: 3px; color: #606266; }

/* 发票管理 + 实物/捆包图 */
.invoice-group { display: grid; gap: 20px; align-content: start; }
.invoice-card { padding: 16px 18px; }
.invoice-head { display: flex; justify-content: space-between; align-items: center; }
.invoice-actions { display: flex; align-items: center; gap: 12px; }
.invoice-actions .el-button { margin: 0; }
/* 通关信息：第一行品名+HSCODE，第二行材质 */
.clearance-grid { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 12px 28px; margin-top: 14px; }
.clearance-field { min-width: 0; }
.clearance-field:nth-child(4n + 2),
.clearance-field:nth-child(4n + 3),
.clearance-field:nth-child(4n + 4) { padding-left: 18px; border-left: 1px solid #ebeef5; }
.clearance-field label { display: block; margin-bottom: 6px; color: #666; font-size: 14px; line-height: 20px; }
.clearance-field .el-textarea { width: 100%; }
::v-deep .clearance-field .el-textarea__inner {
  min-height: 32px;
  padding: 6px 10px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #fff;
  color: #333;
  line-height: 20px;
}
.image-card { display: grid; grid-template-columns: minmax(0, 1fr) 1px minmax(0, 1fr); gap: 24px; min-width: 0; padding: 16px 18px; }
.image-divider { background: #dcdfe6; }
.image-group { min-width: 0; }
.image-group-head { display: flex; align-items: center; justify-content: space-between; margin-bottom: 16px; }
.image-group-head button,
.file-category-head button { height: 26px;line-height: 26px; padding: 0 10px; border: 0; border-radius: 3px; background: #15ad3c; color: #fff; font-size: 12px; cursor: pointer; }
.image-list { display: flex; width: 100%; max-width: 100%; min-width: 0; height: 96px; box-sizing: border-box; gap: 18px; overflow-x: auto; overflow-y: hidden; padding-bottom: 8px; }
.image-item { position: relative; flex: 0 0 80px; }
.image-list .el-image { display: block; width: 80px; height: 80px; border-radius: 6px; cursor: zoom-in; }
.image-item > button { position: absolute; z-index: 2; top: 0; right: 0; width: 20px; height: 20px; padding: 0; border: 0; border-radius: 50%; background: #b4272d; color: #fff; cursor: pointer; }
.file-card { overflow: hidden; }
.file-category { margin-top: 14px; padding-bottom: 12px; border-bottom: 1px solid #ebeef5; }
.file-category-head { display: flex; align-items: center; justify-content: space-between; margin-bottom: 8px; }
.file-category-head strong { font-size: 13px; }
.file-links { min-width: 0; }
.file-row { display: grid; grid-template-columns: minmax(0, 1fr) 24px; align-items: center; gap: 6px; min-height: 22px; }
.file-category a { display: block; overflow: hidden; color: #0d4fe6; font-size: 12px; line-height: 20px; text-overflow: ellipsis; white-space: nowrap; }
.file-row > button { padding: 0; border: 0; background: transparent; color: #b4272d; cursor: pointer; }
.file-card > .el-checkbox { margin: 12px 12px 0 0; }

/* 贩售方案 Tab 与编辑器 */
.plan-shell { margin-top: 24px; }
.plan-tabs { display: flex; align-items: center; height: 40px; }
.plan-tabs > button { height: 38px; padding: 0 20px; border: 0; border-bottom: 2px solid transparent; background: transparent; cursor: pointer; }
.plan-tabs > button.active { border-color: #b4272d; color: #b4272d; }
.plan-create { display: flex; align-items: center; gap: 12px; margin-left: auto; }
.plan-content { margin-top: 24px; }
.plan-name-row { display: grid; grid-template-columns: auto 460px 1fr auto auto; align-items: center; gap: 12px; height: 40px; }
.plan-name-row .el-button { margin: 0; }
.subsection,
.notice-card,
.tag-card { margin-top: 24px; padding: 24px; border-radius: 8px; background: #fff; }
.subsection > h3 { margin-bottom: 24px; }
/* 原生表格布局（plan-editor 内链接/OPTION 等复用） */
.native-table { width: 100%; overflow: hidden; }
.table-head { min-height: 54px; background: #edeff4; }
.table-row { min-height: 112px; border-bottom: 1px solid #dcdfe6; background: #fff; }
.table-head,
.table-row { display: grid; }
.table-head > div,
.table-row > div { box-sizing: border-box; display: flex; align-items: center; justify-content: center; min-width: 0; padding: 10px; }
.link-grid { grid-template-columns: 320fr 120fr 320fr 100fr 80fr 260fr; }
.link-cell { flex-direction: column; align-items: stretch !important; }
.link-cell p { margin: 8px 0 0; color: #f08804; font-size: 12px; }
.table-product-image { width: 100px; height: 100px; border-radius: 8px; background: #d8d8d8; }
.attribute-list { display: block !important; }
.attribute-list p { margin: 5px 0; }
.row-actions { flex-wrap: wrap; gap: 8px; }
.row-actions .el-button { margin: 0; }
.row-actions button:not(.el-button),
.option-grid button { border: 0; background: none; color: #b4272d; cursor: pointer; }
.notice-grid { display: grid; grid-template-columns: repeat(5, 1fr); gap: 20px; margin-top: 24px; }
.notice-label { display: flex; justify-content: space-between; align-items: flex-start; min-height: 42px; }
.section-toolbar { display: flex; justify-content: space-between; align-items: center; margin-bottom: 24px; }
.section-toolbar .el-button { margin-left: 12px; }
.option-grid { grid-template-columns: 80fr 200fr 200fr 166fr 80fr 194fr 194fr 184fr 200fr 50fr; }
.option-table .table-row { min-height: 148px; }
.option-grid .el-radio { display: block; margin: 5px 0; }
.media-list { display: grid !important; grid-template-columns: repeat(3, 50px); gap: 12px; }
.media-list img,
.media-list video { display: block; width: 50px; height: 50px; border-radius: 4px; object-fit: cover; }
.small-file-list { display: block !important; }
.small-file-list a { display: block; overflow: hidden; color: #0d4fe6; text-overflow: ellipsis; white-space: nowrap; }
.tag-row-detail { display: grid; grid-template-columns: 240px 1fr; gap: 30px; padding: 24px 0; border-top: 1px solid #dcdfe6; }
.tag-preview { display: flex; flex-direction: column; justify-content: center; align-items: center; min-height: 160px; border: 1px solid #dcdfe6; }
.tag-preview span { margin-top: 20px; font-size: 18px; }
.tag-fields { display: grid; grid-template-columns: repeat(4, 1fr); gap: 16px; }
.tag-fields label { color: #666; }
.tag-fields .el-input { margin-top: 6px; }
.empty-plan { padding: 80px; text-align: center; }

/* 下单记录区 */
.records-shell { margin-top: 24px; padding: 24px; background: #fff; }
.records-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px; gap: 16px; }
.records-title { display: flex; align-items: center; flex-wrap: wrap; gap: 12px; min-width: 0; }
.records-title h2 { margin: 0; }
.records-tip { margin: 0; color: #b4272d; font-size: 13px; line-height: 20px; }
.sync-btn { flex-shrink: 0; border-color: #b4272d; background: #b4272d; }
.order-grid { grid-template-columns: 2fr 1fr 1fr 2fr 1fr; }
.order-table { max-height: 500px; overflow-x: hidden; overflow-y: auto; }
.order-table .table-head { position: sticky; top: 0; z-index: 1; } /* 表格内表头 sticky */
.order-table .table-row { min-height: 72px; }
.order-table a { color: #b4272d; }
.order-type-cell { flex-direction: column; }
.order-type-cell p { margin: 2px 0; line-height: 20px; }
.reparation-links { flex-direction: column; gap: 8px; }
.reparation-item { display: flex; flex-direction: column; gap: 3px; }
.reparation-responsible { margin: 0; color: #666; font-size: 12px; line-height: 18px; }
.history-pagination { margin-top: 20px; text-align: center; }
::v-deep .el-input__inner,
::v-deep .el-textarea__inner { border-color: #dcdfe6; border-radius: 4px; color: #333; }
::v-deep .el-textarea__inner { font-family: inherit; }
</style>
